import React from 'react';
import styles from './Divider.module.scss';

const Divider = () => <hr className={styles.divider} />;

export default Divider;
